import { uiActionTypes as actionType } from 'src/constants/actionTypes';

const initialState = { loading: 0 };

const uiReducer = (state = initialState, { type }) => {
  switch (type) {
    case actionType.START_ACTION:
      return {
        ...state,
        loading: state.loading + 1
      };

    case actionType.STOP_ACTION:
      return {
        ...state,
        loading: state.loading > 0 ? state.loading - 1 : 0
      };

    default:
      return state;
  }
};

export default uiReducer;
